import comparisonSlider from 'img-comparison-slider';
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";


jQuery(document).ready(function ($) {

   $('img-comparison-slider').each(function(index) {
      $('img-comparison-slider').get(index).value = 30;
   })

   $('.customer-reviews-swiper').each(function () {
      new Swiper(this, {
         modules: [Pagination],
         wrapperClass: 'customer-reviews-swiper-wrapper',
         slideClass: 'customer-review',
         slidesPerView: 1,
         spaceBetween: 0,
         pagination: {
            el: '.customer-reviews-swiper-pagination',
            clickable: true,
         },
      });
   });

   $('.selected-projects-swiper').each(function () {
      new Swiper(this, {
         modules: [Pagination, Autoplay],
         wrapperClass: 'selected-projects-swiper-wrapper',
         slideClass: 'project-card',
         slidesPerView: 'auto',
         spaceBetween: 30,
         pagination: {
            el: '.selected-projects-swiper-pagination',
            clickable: true,
         },
         autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
         },
         loop: true,
      });
   });

   const lightbox = new PhotoSwipeLightbox({
      gallery: '.image-gallery-photoswipe',
      children: 'a',
      pswpModule: PhotoSwipe,
      tapAction: (point, event) => {
         if (event.target.classList.contains('pswp__img')) {
            // Toggle the UI visibility
            pswp.element.classList.toggle('pswp--ui-visible');
         } else {
            // Close the lightbox
            pswp.close();
         }
     },
   });

   // Add this function to find and open the image
   function openImageFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const imageId = params.get('v');
      
      if (!imageId) return;

      // Find all galleries
      const galleries = document.querySelectorAll('.image-gallery-photoswipe');
      
      for (const gallery of galleries) {
         // Find the link with matching image ID
         const imageLink = gallery.querySelector(`a[data-image-id="${imageId}"]`);
         
         if (imageLink) {
            // First scroll 40px above the gallery and image thumbnail
            // to give context about where this image is located
            const yPosition = imageLink.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({top: yPosition, behavior: 'auto'});
            
            // Get the index of this image within its gallery
            const links = Array.from(gallery.querySelectorAll('a'));
            const index = links.indexOf(imageLink);
            
            lightbox.loadAndOpen(index, { gallery });
            
            return; // Exit after finding and opening the first match
         }
      }
   }

   // Update URL when image changes
   lightbox.on('change', () => {
      const currSlide = lightbox.pswp.currSlide;
      if (currSlide) {
         const imageId = currSlide.data.element.dataset.imageId;
         if (imageId) {
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set('v', imageId);
            window.history.replaceState({}, '', newUrl);
         }
      }
   });

   // Reset URL when gallery closes
   lightbox.on('close', () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('v');
      window.history.replaceState({}, '', url);
   });

   // Initialize lightbox first
   lightbox.init();
   
   // Then immediately call the function to open from URL
   openImageFromUrl();

   $('.mobile-menu-trigger').on('click', function() {
     $(this).toggleClass('active');
     $('.mobile-menu').toggleClass('active');
   });

   // Get all anchor links in the mobile menu
   const $mobileMenu = $('.mobile-menu');
   if ($mobileMenu.length) {
     // Find all anchor links within the mobile menu
     const $anchorLinks = $mobileMenu.find('a[href*="#"]');
     
     // Add click event listener to each anchor link
     $anchorLinks.on('click', function() {
       // Get the href attribute
       const href = $(this).attr('href');
       
       // Check if this is an anchor link on the current page
       if (href.includes('#')) {
         // Extract the URL part (before the #)
         const urlPart = href.split('#')[0];
         
         // If urlPart is empty or matches current page path, it's a same-page anchor
         if (urlPart === '' || urlPart === window.location.pathname) {
           // Small delay to allow the browser to start scrolling before closing the menu
           setTimeout(function() {
             // Remove the 'active' class from the mobile menu
             $mobileMenu.removeClass('active');
             
             // If you have a hamburger button that needs to be toggled
             const $hamburgerButton = $('.mobile-menu-trigger');
             if ($hamburgerButton.length && $hamburgerButton.hasClass('active')) {
               $hamburgerButton.removeClass('active');
             }
           }, 100);
         }
       }
     });
   }
});
